import { css } from "../../../styled-system/css";

export const styles = {
  section: () =>
    css({
      maxWidth: "1200px",
      marginX: "auto",
      paddingX: "baseUnit.mobile4",
      desktop: {
        paddingX: "baseUnit.mobile16",
      },
    }),

  headlines: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
      marginBottom: "baseUnit.mobile2",
      desktop: {
        marginBottom: "baseUnit.mobile4",
      },
    }),

  heading: () =>
    css({
      color: "midnight",
      fontSize: "heading.H2.mobile",
      fontWeight: 800,
      lineHeight: "heading.H1.mobile",
      letterSpacing: "heading.H1.mobile",
      overflowWrap: "normal",
      hyphens: "none",
      marginBottom: 0,
      desktop: {
        fontSize: "heading.H1.desktop",
        letterSpacing: "heading.H1.desktop",
      },
    }),

  list: () =>
    css({
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "baseUnit.mobile2",
      desktop: {
        gridTemplateColumns: "repeat(2, 368px)",
        columnGap: "baseUnit.mobile2",
        rowGap: "baseUnit.mobile2",
        justifyContent: "start",
      },
    }),

  listItem: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile2",
    }),

  link: () =>
    css({
      color: "ink",
      textDecoration: "none",
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "skyBlue",
        outlineOffset: "2px",
        borderRadius: "2px",
      },
    }),

  label: () =>
    css({
      textDecoration: "underline",
      textDecorationStyle: "dotted",
      textUnderlineOffset: "3px",
      fontSize: "body.shrimp",
      fontWeight: 700,
      lineHeight: "body.shrimp",
      letterSpacing: "body.shrimp",
      "a:hover &": {
        textDecorationStyle: "solid",
      },
      "@supports (-webkit-appearance: none) and (not (-moz-appearance: none))": {
        textDecoration: "none",
        backgroundImage: "radial-gradient(circle, currentColor 0.5px, transparent 1px)",
        backgroundPosition: "-1px calc(100% - 1px)",
        backgroundSize: "4px 2px",
        backgroundRepeat: "repeat-x",
        "a:hover &": {
          backgroundImage: "linear-gradient(currentColor, currentColor)",
          backgroundSize: "100% 1px",
        },
        desktop: {
          fontSize: "body.mouse",
        },
      },
    }),

  iconWrapper: () =>
    css({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: "baseUnit.mobile5",
      height: "baseUnit.mobile5",
      borderRadius: "50%",
      backgroundColor: "skyBlue",
      color: "white",
    }),
};
